import React from "react";

import { TableCell, Typography } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";

interface CellWithTooltipProps {
  value: string | number;
  isActive?: boolean;
  onClick?: (event: React.MouseEvent<HTMLTableCellElement>) => void;
  style?: React.CSSProperties | any;
  currency?: string;
}

export const CellWithTooltip: React.FC<CellWithTooltipProps> = ({ value, onClick, style, isActive, currency }) => {
  const formattedValue = currency
    ? `${currency} ${value.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`
    : value;

  return (
    <TableCell
      sx={{ ...style, ...(isActive ? { cursor: "pointer", color: "#26A6AE" } : { cursor: "default" }) }}
      onClick={(e) => {
        if (!isActive) return;
        e.stopPropagation();
        onClick && onClick(e);
      }}
    >
      <MaterialTooltip title={formattedValue}>
        <Typography
          noWrap
          style={{
            display: "block",
            width: "100%",
            maxWidth: "200px"
          }}
        >
          {formattedValue || ""}
        </Typography>
      </MaterialTooltip>
    </TableCell>
  );
};
